import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { hideModal } from '../../../redux/modules/modal';

const ButtonGroup = ({
  secondaryLabel = 'Cancel',
  label = 'Confirm',
  justify = 'center',
  size = 'md',
  width = 'auto',
  secondaryClick,
  onClick = () => {},
  dataAnalyticsId = '',
  secondaryDataAnalyticsId = '',
  secondaryDuskId = undefined,
  isLoading = false,
  loadingText = '',
  isDisabled = false,
  primaryCypressId = undefined,
  secondaryCypressId = undefined
}) => {
  const dispatch = useDispatch();
  const close = () => dispatch(hideModal());
  const secondClick = secondaryClick || close;

  return (
    <Flex justifyContent={justify} width="100%">
      <Button
        data-analytics-id={secondaryDataAnalyticsId}
        data-cy={secondaryCypressId}
        dusk={secondaryDuskId}
        size={size}
        variant="secondary"
        width={width}
        onClick={secondClick}
      >
        {secondaryLabel}
      </Button>
      <Button
        data-analytics-id={dataAnalyticsId}
        data-cy={primaryCypressId}
        dusk={dataAnalyticsId}
        isDisabled={isDisabled}
        isLoading={isLoading}
        loadingText={loadingText}
        ml={3}
        size={size}
        variant="gradientSuccess"
        width={width}
        onClick={onClick}
      >
        {label}
      </Button>
    </Flex>
  );
};

ButtonGroup.propTypes = {
  /** Text displayed on main/confirm button. Defaults to 'Confirm' */
  label: PropTypes.string,
  /** Text displayed on secondary button. Defaults to 'Cancel' */
  secondaryLabel: PropTypes.string,
  /** How buttons should be justified in their parent container. Defaults to `center` */
  justify: PropTypes.string,
  /** Size of buttons. Defaults to `md` */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  /** Width of buttons. Defaults to `auto` */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Event handler for main/confirm button */
  onClick: PropTypes.func,
  /** Event handler for secondary/cancel button. Defaults to `() => dispatch(hideModal())` */
  secondaryClick: PropTypes.func,
  /** Analytics tracking id for main button */
  dataAnalyticsId: PropTypes.string,
  /** Analytics tracking id for secondary button */
  secondaryDataAnalyticsId: PropTypes.string,
  /** Dusk testing id for secondary button */
  secondaryDuskId: PropTypes.string,
  /** Can be used in place of isDisabled for form submissions to show loading state */
  isLoading: PropTypes.bool,
  /** Button text to show while loading. If isLoading is specified without text, the spinner will render by itself */
  loadingText: PropTypes.string,
  /** Disable button */
  isDisabled: PropTypes.bool,
  /** e2e testing id for primary button */
  primaryCypressId: PropTypes.string,
  /** e2e testing id for primary button */
  secondaryCypressId: PropTypes.string
};

export default ButtonGroup;
